// Период напоминания: раз в столько дней оно возвращается. Период меньше единицы (ноль,
// отрицательный) или дробный смысла не имеет, а огромный не помещается в колонку. Те же правила
// проверяет сервер (services/main, helpers/reminderPeriod.js).
export const PERIOD_MAX = 3650; // десять лет

// Что сказать человеку про период (пустая строка, если всё в порядке).
export const periodError = (value) => {
  const number =
    typeof value === "number" ? value : typeof value === "string" && value.trim() ? Number(value.trim()) : NaN;
  if (!Number.isInteger(number)) return "Периодичность: целое число дней, не меньше 1";
  if (number < 1) return "Периодичность: не меньше 1 дня";
  if (number > PERIOD_MAX) return `Периодичность: не больше ${PERIOD_MAX} дней`;
  return "";
};
